import type { Route } from '../types/routeTypes'

type PagingResult = {
  prev?: Route<string>
  current?: Route<string>
  next?: Route<string>
}

// Cache the routes and allowed state keys
export const PAGES_CACHE: Route<string>[] = []

// Cache promo code
let PROMO_CODE_CACHE: string | undefined

export const setPromoCodeNavigationCache = (promoCode: string | undefined) => {
  PROMO_CODE_CACHE = promoCode
}

export const evaluateRouteCondition = (
  route: Route<string>,
  data?: Record<string, unknown>
) => {
  return route.path && route.condition && data
    ? route.condition(data, { promoCode: PROMO_CODE_CACHE })
    : true
}

/**
 * Returns the paging result for the given path, promo, and data.
 */
export const getPaging = ({
  path,
  data,
}: {
  path: string
  data?: Record<string, unknown>
}): PagingResult => {
  if (!PAGES_CACHE.length) {
    return {}
  }

  const pages = PAGES_CACHE.filter((route) =>
    evaluateRouteCondition(route, data)
  )

  // Find the index of the current page
  const currentIndex = pages.findIndex((route) => route.path === path)

  if (currentIndex === -1) {
    return {}
  } else {
    // Get the current, previous, and next pages
    const prevIndex = currentIndex - 1
    const nextIndex = currentIndex + 1
    const prev = prevIndex >= 0 ? pages[prevIndex] : undefined
    const current = pages[currentIndex]
    const next = nextIndex < pages.length ? pages[nextIndex] : undefined

    return {
      prev,
      current,
      next,
    }
  }
}
